import React from 'react';
import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';

export const HeaderCellBase = ({ classes, className, ...restProps }) => {
  return <TableHeaderRow.Cell {...restProps} className={classes.cell} />;
};
